<template>
    <templatePublicComponent>
        <v-container style="padding-top:5px;padding-left:0px;padding-right:0px;">
            <v-layout wrap>
                <v-flex xs12 sm12 md12>
                    <!-- <v-card color="#1f4e9926">
                        <v-card-title style="margin-bottom:0px;padding-bottom:0px;">
                            <span class="headline">Offre d'emploi</span>
                        </v-card-title>
                        <v-card-text>
                            <div>
                                <h6>Chauffeur avec exprérience demandé</h6>
                                <p><a href="mailto:info@deneigementstecatherine.com?subject=Offre d'emploi">Envoyer votre C.V.</a></p>
                            </div>
                        </v-card-text>
                    </v-card> -->
                    <v-card color="#1f4e9926">
                        <v-card-text>
                            <div style="font-size: 22px;text-align: center;">
                                Nous offrons notre service de déneigement résidentiel uniquement pour la ville de Ste-Catherine depuis plus de 30 ans.  Toujours soucieux d’offrir un service de qualité, notre entreprise compte plus d’une trentaine de tracteurs avec souffleur munis de couteaux en téflon ainsi qu’une main d’œuvre d’expérience désireuse de satisfaire les clients.
                            </div>
                        </v-card-text>
                    </v-card>
                    <v-card color="#1f4e9926">
                        <v-card-title style="margin-bottom:0px;padding-bottom:0px;">
                            <span class="headline">Événements</span>
                        </v-card-title>
                        <v-card-text>
                            <div v-for="item in eventitems" :key="item.ID">
                                <h6>{{item.Date | formatDateTime}}</h6>
                                <p>{{item.Description}}</p>
                            </div>
                            <div>
                                <router-link class="nav-link" active-class="active" to="/evenements" style="padding-left:0px;">Voir plus ...</router-link>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </templatePublicComponent>
</template>

<script>
import moment from 'moment'
import TemplatePublicComponent from '@/components/TemplatePublic.vue'
import APIEvent from '@/api/event'
const APIService = new APIEvent();

var axios = require('axios')

export default {
    components:
    {
        TemplatePublicComponent
    },
    data () {
        return {
            eventitems: [],
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        initialize () {
            var events = APIService.getTop().then(response =>  {
                this.eventitems = response.data
            }
        )}
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Accueil.vue